<template>
    <div class="InfiniteScroll"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="10">

        <div class="itemBox" 
            v-for="item in my_task"
            :key="item.id">
            <div class="imgBox"><img style=" filter: blur(4px) " :src="item.icon" alt=""></div>
            <div class="item">
                <p class="itemTitle" style="width:1.7rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{item.name}}</p>
            </div>
            <div class="spanBox">
                <span class='out'>＋<span class='in'>{{item.price}}</span>元</span>
            </div>
        </div>
    </div>
</template>

<script>
import {Toast} from "mint-ui"

export default {
    data(){
       return {
            my_task:[],
            page:1,
            loading:false,
            hasMore:false,
        } 
    },
    methods:{
        loadMore(){
            const _this = this;
            if(_this.hasMore){
                _this.loading = true
                Toast({
                    message: '没有更多数据了',
                    position: 'bottom',
                })
                return false
            }
            _this.loading = true
            function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { 
                    return callback(WebViewJavascriptBridge); 
                }
                if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { 
                    document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }                                                                                                      
            setupWebViewJavascriptBridge(function(bridge) {
                bridge.callHandler('encrypt', {
                    uid : localStorage.getItem("UID"),
                    idfa : localStorage.getItem("IDFA"),
                    udid : localStorage.getItem("UDID"),
                    ip : localStorage.getItem("IP"),
                    device : localStorage.getItem("DEVICE"),
                    os : localStorage.getItem("OS"),
                    page: _this.page,
                    request_time : Date.parse(new Date())
                }, function(response) {        //加密获取到的数据 
                    let userInfoCode = response.dataReq
                    let userInfoSign = response.dataSign
                    _this.$axios.post("/api/task/tlist", {      
                        code : userInfoCode,
                        dataSign : userInfoSign,
                    }).then(res=>{       //发送给后端加密数据 code和md5值，同时获取后端api的加密数据
                        bridge.callHandler('decrpt', {
                            dataReq : res.data.dataReq,
                            dataSign : res.data.dataSign,
                        }, function(response) {  
                            _this.loading = false
                            _this.my_task = _this.my_task.concat(response.info.data.my_task)
                            if(response.info.data.my_task.length === 0){
                                _this.hasMore = true
                                return false
                            }else{
                                _this.page++
                            }
                        })
                    })
                })
            })
        },
    },
}

</script>
<style lang="scss" scoped>
        .itemBox{
            width:100%;
            height:.75rem;
            display:flex;
            align-items: center;
            position:relative;
            .imgBox{
                width:.55rem;
                height:.55rem;
                margin:0 0.05rem 0 .1rem;
            }
            .itemTitle{
                font-size: .16rem;
            }
            .itemText{
                font-size: .12rem;
                color:#555555;
            }
            .spanBox{
                width:1rem;
                height:.34rem;
                position:absolute;
                right:0.14rem;
                display:flex;
                align-items: center;
                .out{
                    color:red;
                    font-size: .12rem;
                    position:absolute;
                    right:0;
                    .in{
                        font-size: 0.25rem;
                    }
                }
            }
            .hidden{
                    color:red; 
                    position:fixed;
                    left:-10000px;
                }
        }

</style>
